/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventType } from './EventType';
import {
	EventTypeFromJSON,
	EventTypeFromJSONTyped,
	EventTypeToJSON,
	EventTypeToJSONTyped,
} from './EventType';
import type { EventBehavior } from './EventBehavior';
import {
	EventBehaviorFromJSON,
	EventBehaviorFromJSONTyped,
	EventBehaviorToJSON,
	EventBehaviorToJSONTyped,
} from './EventBehavior';

/**
 *
 * @export
 * @interface EventConfiguration
 */
export interface EventConfiguration {
	/**
	 *
	 * @type {EventType}
	 * @memberof EventConfiguration
	 */
	eventType?: EventType;
	/**
	 *
	 * @type {Array<EventBehavior>}
	 * @memberof EventConfiguration
	 */
	eventBehaviors?: Array<EventBehavior> | null;
}

/**
 * Check if a given object implements the EventConfiguration interface.
 */
export function instanceOfEventConfiguration(value: object): value is EventConfiguration {
	return true;
}

export function EventConfigurationFromJSON(json: any): EventConfiguration {
	return EventConfigurationFromJSONTyped(json, false);
}

export function EventConfigurationFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EventConfiguration {
	if (json == null) {
		return json;
	}
	return {
		eventType: json['eventType'] == null ? undefined : EventTypeFromJSON(json['eventType']),
		eventBehaviors:
			json['eventBehaviors'] == null
				? undefined
				: (json['eventBehaviors'] as Array<any>).map(EventBehaviorFromJSON),
	};
}

export function EventConfigurationToJSON(json: any): EventConfiguration {
	return EventConfigurationToJSONTyped(json, false);
}

export function EventConfigurationToJSONTyped(
	value?: EventConfiguration | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		eventType: EventTypeToJSON(value['eventType']),
		eventBehaviors:
			value['eventBehaviors'] == null
				? undefined
				: (value['eventBehaviors'] as Array<any>).map(EventBehaviorToJSON),
	};
}
